module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    staticClass: "modal-lg",
    attrs: {
      "modal-title": 'Campaign Details'
    },
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "campaign-details"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', [_vm._v("Details")]), _vm._v(" "), _c('dl', {
    staticClass: "detail-list"
  }, [_c('dt', [_vm._v("Name")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.campaignModel.name || "-"))]), _vm._v(" "), _c('dt', [_vm._v("Provider")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.providerName || "-"))]), _vm._v(" "), _c('dt', [_vm._v("Type")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.campaignTypeLabel))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', [_vm._v("Status")]), _vm._v(" "), _c('dl', {
    staticClass: "detail-list"
  }, [_c('dt', [_vm._v("Active")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.campaignModel.current_status.is_active ? "Yes" : "No"))]), _vm._v(" "), _c('dt', [_vm._v("Test")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.campaignModel.current_status.is_test ? "Yes" : "No"))]), _vm._v(" "), _c('dt', [_vm._v("Return Grades")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.campaignModel.return_grades ? "Yes" : "No"))]), _vm._v(" "), _c('dt', [_vm._v("Rule for Agent Zone Matching")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.agentZoneRuleLabel || "-"))]), _vm._v(" "), (_vm.campaignModel.campaign_type === 'ping-post') ? [_c('dt', [_vm._v("Bid")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.campaignModel.bid != null ? _vm.campaignModel.bid : "-"))])] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h3', [_vm._v("Tags")]), _vm._v(" "), _c('tags-widget', {
    attrs: {
      "tags": _vm.campaignModel.tags,
      "read-only": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h3', [_vm._v("Fields")]), _vm._v(" "), (_vm.campaignModel.fields.length) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Field")]), _vm._v(" "), _c('th', [_vm._v("API Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Default Value")]), _vm._v(" "), _c('th', [_vm._v("Notes")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.campaignModel.fields), function(f, ix) {
    return _c('tr', {
      key: ix
    }, [_c('th', {
      staticClass: "align-middle"
    }, [_vm._v("\n                " + _vm._s(f.field && _vm.fieldOptions[f.field] ? _vm.fieldOptions[f.field].name : "-") + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(f.alias || "-"))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(_vm.fieldTypeLabel(f)))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(f.default_value || "-"))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(f.notes || "-"))])])
  }), 0)]) : _c('p', [_c('i', [_vm._v("No fields")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_vm._v("Billing Condition")]), _vm._v(" "), _c('boolean-expression', {
    attrs: {
      "expression": _vm.campaignModel.billing_condition,
      "edit-mode": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_vm._v("Capacity Limits")]), _vm._v(" "), _c('table', {
    staticClass: "table table-borderless"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Hourly")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignModel.capacity.hourly != null ? _vm.campaignModel.capacity.hourly : "-"))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Daily")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignModel.capacity.daily != null ? _vm.campaignModel.capacity.daily : "-"))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Weekly")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignModel.capacity.weekly != null ? _vm.campaignModel.capacity.weekly : "-"))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Monthly")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignModel.capacity.monthly != null ? _vm.campaignModel.capacity.monthly : "-"))])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d85a842"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CampaignModal.vue
// module id = 671
// module chunks = 0